export const TestIds = {
  link: 'link',
  linkImageContainer: 'linkImageContainer',
} as const;
